export const computeTotalAmount = ({
  useNewTotalCalculations,
  total,
  proratedDays,
  totalAdjustment,
  totalCarryover,
}: {
  useNewTotalCalculations: boolean
  total: number | string
  proratedDays: number | string
  totalAdjustment: number | string
  totalCarryover: number | string
}): number => {
  if (useNewTotalCalculations) return +total

  return +proratedDays + +totalAdjustment + +totalCarryover
}
